<script lang="ts">
  import ChevronDownIcon from "../utils/assets/chevron_down.svelte";
  import { onMount } from "svelte";

  interface Option {
    value: string;
    label: string;
  }

  export let options: Option[] = [];
  export let selectedValue: string = "";
  export let placeholder: string = "Select an option";
  export let onSelect: (value: string) => void = () => {};

  let isOpen = false;
  let dropdownContainer: HTMLElement;

  $: selectedOption = options.find((option) => option.value === selectedValue);

  function handleClickOutside(event: MouseEvent) {
    if (
      dropdownContainer &&
      !dropdownContainer?.contains(event?.target as Node)
    ) {
      isOpen = false;
    }
  }

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function selectOption(option: Option) {
    onSelect(option.value);
    isOpen = false;
  }

  onMount(() => {
    document?.addEventListener("click", handleClickOutside);
    return () => {
      document?.removeEventListener("click", handleClickOutside);
    };
  });
</script>

<div
  bind:this={dropdownContainer}
  class="verbaflo-widget-select-dropdown-container"
>
  <button
    type="button"
    on:click={toggleDropdown}
    class="verbaflo-widget-select-dropdown-button"
  >
    <span
      class="verbaflo-widget-select-dropdown-text"
      class:placeholder={!selectedOption}
    >
      {selectedOption?.label || placeholder}
    </span>
    <ChevronDownIcon />
  </button>
  {#if isOpen}
    <div class="verbaflo-widget-select-dropdown-options-container">
      {#each options as option}
        <button
          type="button"
          on:click={() => selectOption(option)}
          class:selected={selectedValue === option.value}
          class="verbaflo-widget-select-dropdown-option"
        >
          {option.label}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style>
  :global(#vfwidget .verbaflo-widget-select-dropdown-container) {
    position: relative !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-button) {
    font-size: 14px !important;
    font-weight: 400 !important;
    border: 1px solid #d0d5dd !important;
    border-radius: 8px !important;
    padding: 10px !important;
    width: 100% !important;
    outline: none !important;
    box-shadow: none !important;
    text-transform: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    cursor: pointer !important;
    background-color: #ffffff !important;
    margin: 0px !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-button:focus) {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-text) {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #181d27 !important;
    margin: 0px !important;
    padding: 0px !important;
    line-height: normal !important;
    text-align: left !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-text.placeholder) {
    color: #667085 !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-options-container) {
    position: absolute !important;
    top: 100% !important;
    left: 0px !important;
    right: 0px !important;
    z-index: 1000 !important;
    background-color: #ffffff !important;
    border: 1px solid #ededed !important;
    border-radius: 8px !important;
    box-shadow:
      0px 0px 4px rgba(0, 0, 0, 0.04),
      0px 4px 8px rgba(0, 0, 0, 0.06) !important;
    margin-top: 4px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  :global(
      #vfwidget
        .verbaflo-widget-select-dropdown-options-container::-webkit-scrollbar
    ) {
    display: none !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-option) {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #181d27 !important;
    margin: 0px !important;
    padding: 8px 12px !important;
    line-height: normal !important;
    cursor: pointer !important;
    opacity: 1 !important;
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    border-radius: 0px !important;
    text-align: left !important;
    width: 100% !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-option:hover) {
    background-color: #eef4ff !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-option.selected) {
    background-color: #f3f4f6 !important;
    font-weight: 500 !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-option:first-child) {
    border-radius: 8px 8px 0px 0px !important;
  }

  :global(#vfwidget .verbaflo-widget-select-dropdown-option:last-child) {
    border-radius: 0px 0px 8px 8px !important;
  }
</style>
